import React from 'react';
import './contact.css';

const Map = () => {
  return (
    <div className="map-container shadow-sm rounded overflow-hidden">
      <iframe
        title="location-map"
        src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14007.53!2d77.314944!3d28.582778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
        width="100%"
        height="460"  // 🔼 Increased height here
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Map;
